import { cn } from '@/lib/utils';

interface ConnectionStatusProps {
  connected: boolean;
  connectedLabel?: string;
  disconnectedLabel?: string;
  labelClassName?: string;
}

export const ConnectionStatus = (props: ConnectionStatusProps) => (
  <>
    <span
      className={cn(
        'h-1.5 w-1.5 rounded-full',
        props.connected ? 'bg-emerald-400' : 'bg-zinc-600',
      )}
    />
    <span className={cn('text-[11px] text-zinc-500', props.labelClassName)}>
      {props.connected
        ? (props.connectedLabel ?? 'Live')
        : (props.disconnectedLabel ?? 'Offline')}
    </span>
  </>
);
